export default "__VITE_ASSET__DsHMRuAZ__"